






















































import { computed, defineComponent, watch } from "@vue/composition-api";
import useContacts from "@/store/useContacts";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { app } from "@/store/index";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./Sensors/SensorHeader.vue"),
    },
    setup() {
        const { contacts, getContacts } = useContacts();
        const { update } = useContact();

        const toogleActive = (contact: ContactViewModel) => {
            contact.active = !contact.active;
            update(contact).then(() => {
                getContacts();
            });
        };

        return {
            contacts,
            toogleActive,
        };
    },
});
